import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  add menu 
export const AddMenu = createSlice({
  name: "AddMenu",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    add_AddMenu: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_add_AddMenu: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;      
    },
    failure_api_call_add_AddMenu: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
      state.switchResponse = true;
    },
    add_AddMenu_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_AddMenu_complete_api: (state, action) => {
      state.api_completed = false;
    },
    clear_AddMenu_Data: (state) => {
      state.data = [];
    },
    false_switchAddMenu_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default AddMenu.reducer;
export const {
  add_AddMenu,
  success_api_call_add_AddMenu,
  failure_api_call_add_AddMenu,
  create_AddMenu_complete_api,
  add_AddMenu_is_success,
  clear_AddMenu_Data,
  false_switchAddMenu_response
} = AddMenu.actions;
